import { ApiLottoIdLottocertificazioniEsportaGetRequest, StatoLottoEnum, TipoEsportazioneCertificazioniEnum } from '@desio/api';
import Abbreviation from 'components/abbreviation';
import Info from 'components/info';
import PaginationComponent from 'components/pagination';
import Text from 'components/text';
import { dateFormat, onKeyPress } from 'helpers/utils';
import * as React from 'react';
import { useEffect } from 'react';
import { Button, Col, Form, Row, Table } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { esportaCertificazioni, getCertificazioniLotto, getDettaglioLotto, refreshCertificazioniLotto, refreshDettaglioLotto, setPaginaSelezionataAction, setRicercaNominativo, setRicercaStatoCertificazione, setRicercaWorkflowCertificazione } from './_redux/actions';
import { certificazioniLotto, dettaglioLotto, dettaglioLottoCompletato, dettaglioLottoInEsecuzione, dettaglioLottoInserito, formRicercaCertificatiSelector, isFirstPageSelector, isLastPageSelector, numeroTotalePagineSelector, paginaSelezionataSelector } from './_redux/selectors';

const pollingMs = 5000;

interface RouteParams {
  id: string
}

export const elencoStatiCertificazioni = [
  { valore: 1, descrizione: "Inserita" },
  { valore: 2, descrizione: "Invalidata" },
  { valore: 3, descrizione: "Scaduta" },
  { valore: 4, descrizione: "Inviata" },
  { valore: 6, descrizione: "Inviata preview" },
  { valore: 5, descrizione: "Certificata" },
];

export const elencoWorkflowCertificazioni = [
  { ordine: 1, valore: 1, descrizione: "Processo AS-IS (FEA)", tooltip: "Invio email a indirizzo email FEA e SMS a numero cellulare Anagrafe" },
  { ordine: 3, valore: 2, descrizione: "Processo mail ANAGRAFE", tooltip: "Invio email a indirizzo email HB avvisando che proseguendo con la certificazione i contatti di HB sovrascriveranno quelli di Anagrafe. Invio SMS a numero cellulare HB" },
  { ordine: 2, valore: 3, descrizione: "Processo mail HB", tooltip: "Contatti HB e Anagrafe coincidono. Invio email a indirizzo email HB e SMS a numero cellulare HB" },
  { ordine: 4, valore: 4, descrizione: "Processo scartato per dati incompleti", tooltip: "Contatti incompleti, certificazione non avviata" },
  { ordine: 5, valore: 5, descrizione: "Processo scartato per altre motivazioni", tooltip: "Certificazione non avviata" },
];

const DettaglioCampagna: React.FC = () => {
  const dispatch = useAppDispatch();
  const { id } = useParams<RouteParams>();
  const certificazioni = useAppSelector(certificazioniLotto);
  const dettaglio = useAppSelector(dettaglioLotto);
  const completato = useAppSelector(dettaglioLottoCompletato);
  const inEsecuzione = useAppSelector(dettaglioLottoInEsecuzione);
  const inserito = useAppSelector(dettaglioLottoInserito);
  const {
    nominativo,
    statoCertificazione,
    workflowCertificazione
  } = useAppSelector(formRicercaCertificatiSelector);

  useEffect(() => {
    setPaginaSelezionata(1);
  }, [dispatch, id]);

  useEffect(() => {
    if (id && dettaglio?.idStatoLotto === StatoLottoEnum.NUMBER_1 || dettaglio?.idStatoLotto === StatoLottoEnum.NUMBER_2) {
      setTimeout(() => {
        dispatch(refreshDettaglioLotto(parseInt(id)));
        dispatch(refreshCertificazioniLotto(parseInt(id)));
      }, pollingMs);
    }
  }, [dettaglio, id]);

  const numeroTotalePagine = useAppSelector(numeroTotalePagineSelector);
  const isFirstPage = useAppSelector(isFirstPageSelector);
  const isLastPage = useAppSelector(isLastPageSelector);
  const paginaSelezionata = useAppSelector(paginaSelezionataSelector);

  const setPaginaSelezionata = (pagina: number) => {
    dispatch(setPaginaSelezionataAction(pagina));
    dispatch(getDettaglioLotto(parseInt(id)));
    dispatch(getCertificazioniLotto(parseInt(id)));
  }

  const esportaCertificazione = (selezione: TipoEsportazioneCertificazioniEnum) => () => {
    const request: ApiLottoIdLottocertificazioniEsportaGetRequest = {
      id: parseInt(id),
      tipoEsportazioneCertificazioni: selezione
    }
    dispatch(esportaCertificazioni(request));
  }

  const handleKeyPress = (event: React.KeyboardEvent<HTMLElement>) => {
    if (event.key === 'Enter' && nominativo) {
      setPaginaSelezionata(1);
    }
    return onKeyPress(event, true);
  };

  function onNominativoChange(evt: any) {
    if (evt.target.value.length <= 12) {
      dispatch(setRicercaNominativo(evt.target.value));
    }
  }

  const ndgCertificabiliTotali = (dettaglio?.datiCertificati?.totaleNdgDaCertificare || 0);
  const ndgTotali = dettaglio?.datiCertificati?.totaleNdg || 0;
  const ndgScartati = ndgTotali - ndgCertificabiliTotali;
  const ndgCertificati = dettaglio?.datiCertificati?.ndgCertificati || 0;
  const ndgCertificatiPerc = ndgCertificabiliTotali ? Math.round((100 * ndgCertificati) / ndgCertificabiliTotali) : 0;

  return (
    <div>
      <Row className="mt-4 mb-4">
        <Col md={12} className="">
          <Text title="Dettaglio della campagna" type='sottotitolo'></Text>
        </Col>
      </Row>
      <Row>
        <Col>
          <Text title="Nome campagna"></Text>
          <Text className="mt-1 mb-3 font-weight-bold" title={dettaglio?.nomeLotto || ""}></Text>
        </Col>
        <Col>
          <Text title="Data inizio campagna"></Text>
          <Text className="mt-1 mb-3 font-weight-bold" title={dateFormat(dettaglio?.dataInizioCampagna)}></Text>
        </Col>
        <Col>
          <Text title="Data fine campagna"></Text>
          <Text className="mt-1 mb-3 font-weight-bold" title={dateFormat(dettaglio?.dataFineCampagna)}></Text>
        </Col>
        <Col>
          <Text title="Stato campagna"></Text>
          <Text className="mt-1 mb-3 font-weight-bold" title={dettaglio?.statoNome || ""}>
            {(inEsecuzione || inserito) &&
              <Info
                text=" L'elaborazione del CSV è eseguita dopo l'inserimento in modo asincrono fino al completamento di tutti gli NDG"
                icon="cog fa-spin"
              />}
          </Text>
        </Col>
      </Row>
      <Row>
        <Col>
          <Text title="NDG scartati"></Text>
          <Text className="mt-1 mb-3 font-weight-bold" title={`${ndgScartati}/${ndgTotali}`}></Text>
        </Col>
        <Col>
          <Text title="NDG certificabili"></Text>
          <Text className="mt-1 mb-3 font-weight-bold" title={`${ndgCertificabiliTotali}/${ndgTotali}`}></Text>
        </Col>
        <Col>
          <Text title="NDG certificati"></Text>
          <Text className="mt-1 mb-3 font-weight-bold" title={`${ndgCertificatiPerc}% ${ndgCertificati}/${ndgCertificabiliTotali}`}></Text>
        </Col>
        <Col></Col>
      </Row>
      <hr />
      <Row className="mt-4 mb-4">
        <Col md={12} className="">
          <Text title="Elenco NDG" type='sottotitolo'></Text>
        </Col>
      </Row>
      <Row style={{ alignItems: 'flex-end' }}>
        <Col>
          <Text title="Nominativo"></Text>
          <Form.Control type="text" onKeyPress={handleKeyPress} onChange={onNominativoChange} value={nominativo} placeholder="nominativo" />
        </Col>
        <Col>
          <Text title="Stato certificazione"></Text>
          <Form.Control as="select" value={statoCertificazione} onChange={(e) => dispatch(setRicercaStatoCertificazione(parseInt(e.target.value)))}>
            <option>Tutti</option>
            {elencoStatiCertificazioni.map((x, index) =>
              <option key={'statoCertificazione_' + index} value={x.valore}>{x.descrizione}</option>
            )}
          </Form.Control>
        </Col>
        <Col>
          <Text title="Processo certificazione"></Text>
          <Form.Control as="select" value={workflowCertificazione} onChange={(e) => dispatch(setRicercaWorkflowCertificazione(parseInt(e.target.value)))}>
            <option>Tutti</option>
            {elencoWorkflowCertificazioni.sort(function (w, z) { return (w.ordine < z.ordine ? -1 : 1) }).map((x, index) =>
              <option key={'workflowCertificazione_' + index} value={x.valore}>{x.descrizione}</option>
            )}
          </Form.Control>
        </Col>
      </Row>
      <Row className="">
        <Col className="text-center mt-3">
          <Button onClick={() => { setPaginaSelezionata(1) }}>Cerca <i className="fas fa-search iconRight ml-2"></i></Button>
          <hr />
        </Col>
      </Row>
      <Row>
        <Col>
          <Table className="small" striped bordered hover responsive>
            <thead>
              <tr>
                <th>Cert.</th>
                <th>Ndg</th>
                <th>Nominativo</th>
                <th>Email FEA</th>
                <th>Email Anagr.</th>
                <th>Cell. Anagr.</th>
                <th>Email HB</th>
                <th>Cell. HB</th>
                <th>Processo</th>
                <th>Data cert.</th>
                <th>Stato</th>
              </tr>
            </thead>
            <tbody>
              {certificazioni.map((arr, index) => (
                <tr key={index}>
                  {/* <td>{arr.id}</td>
                  <td>{arr.ndg}</td> */}
                  <td><Link to={'/admin/ricerca/' + arr.ndg + '/' + arr.idCertificazione}>{arr.idCertificazione}</Link></td>
                  <td><Link to={'/admin/ricerca/' + arr.ndg} >{arr.ndg}</Link></td>
                  <td><Abbreviation title={arr.nominativoNdg} type="s" /></td>
                  <td><Abbreviation title={arr.emailFirmaBiometricaAnagrafe} type="s" /></td>
                  <td><Abbreviation title={arr.emailAnagrafe} type="s" /></td>
                  <td><Abbreviation title={arr.cellulareAnagrafe} type="s" /></td>
                  <td><Abbreviation title={arr.emailHomeBanking} type="s" /></td>
                  <td><Abbreviation title={arr.cellulareHomeBanking} type="s" /></td>
                  <td>
                    {!!arr.idWorkflowCertificazione && <Info text={elencoWorkflowCertificazioni[arr.idWorkflowCertificazione - 1]?.tooltip} />
                    } {arr.workflowCertificazioneNome} {(!!arr.motivazioneScarto) && <Info text={arr.motivazioneScarto} />}</td>
                  <td>{dateFormat(arr.dataCertificazione)}</td>
                  <td>{arr.statoCertificazione || ""}</td>
                </tr>
              ))}
              {certificazioni.length === 0 && (
                <tr key={-1}>
                  <td colSpan={11} className="text-center"><Text title="Nessun risultato presente" /></td>
                </tr>
              )}
            </tbody>
          </Table>
        </Col>
      </Row>
      <Row>
        <Col>
          <PaginationComponent
            numeroTotalePagine={numeroTotalePagine}
            paginaSelezionata={paginaSelezionata}
            isFirstPage={isFirstPage}
            isLastPage={isLastPage}
            setPaginaSelezionata={setPaginaSelezionata}
            elencoRisultati={certificazioni}
          />
        </Col>
      </Row>
      {completato &&
        <Row className="mt-4 pb-5">
          <Col className="text-center">
            <Button className="mr-2" onClick={esportaCertificazione(TipoEsportazioneCertificazioniEnum.NUMBER_0)}>Esporta NDG Certificati <i className="fas fa-file-export iconRight ml-2"></i></Button>
            <Button className="mr-2" onClick={esportaCertificazione(TipoEsportazioneCertificazioniEnum.NUMBER_1)}>Esporta NDG Non Certificati <i className="fas fa-file-export iconRight ml-2"></i></Button>
            <Button className="mr-2" onClick={esportaCertificazione(TipoEsportazioneCertificazioniEnum.NUMBER_2)}>Esporta NDG scartati per dati incompleti <i className="fas fa-file-export iconRight ml-2"></i></Button>
          </Col>
        </Row>}
    </div >
  )
}

export default DettaglioCampagna;
